import AppStoreBadge from '../components/AppStoreBadge';

export default function Download() {
  return (
    <div className="px-6 py-20">
      <div className="mx-auto max-w-4xl">
        {/* Header */}
        <div className="text-center mb-16 px-4">
          <h1 className="text-4xl sm:text-5xl font-bold text-white tracking-tight">Download SwiftDev Toolkit</h1>
          <p className="mt-6 text-base sm:text-lg md:text-xl text-slate-400 max-w-2xl mx-auto">
            A native macOS app for iOS build validation, test execution, and code quality.
          </p>
        </div>

        {/* Download Card */}
        <div className="glass-elevated rounded-[2rem] p-12 relative overflow-hidden">
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-brand-500/5 to-transparent pointer-events-none" />
          
          <div className="relative flex flex-col items-center gap-8">
            <div className="rounded-3xl bg-gradient-to-br from-slate-800 to-slate-900 p-2 shadow-2xl shadow-brand-500/20 border border-brand-400/20">
              <img 
                src="/app-icon.png" 
                alt="SwiftDev Toolkit" 
                className="w-32 h-32 rounded-2xl"
              />
            </div>
            
            <div className="text-center">
              <h2 className="text-3xl font-bold text-white tracking-tight">SwiftDev Toolkit</h2>
              <p className="mt-2 text-lg text-slate-400">Version 1.0 — macOS 14+</p>
            </div>
            
            <AppStoreBadge />

            {/* Requirements */}
            <div className="mt-8 w-full max-w-lg glass-card rounded-2xl p-6 text-left space-y-3 text-sm">
              <div className="flex justify-between">
                <span className="text-slate-400">Requirements:</span>
                <span className="text-white font-medium">macOS 14.0 or later, Xcode 15+</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-400">Size:</span>
                <span className="text-white font-medium">~15 MB</span>
              </div>
              <div className="flex justify-between">
                <span className="text-slate-400">Distribution:</span>
                <span className="text-white font-medium">Mac App Store</span>
              </div>
            </div>
          </div>
        </div>

        {/* Early Access */}
        <div className="mt-12 text-center">
          <p className="text-base text-slate-400">
            Want early access? Contact us at{' '}
            <a 
              href="mailto:hello@swiftdevtoolkit.com" 
              className="text-brand-400 hover:text-brand-300 transition-colors font-medium hover:underline"
            >
              hello@swiftdevtoolkit.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
